// angular
import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from "@angular/core";

// TODO: understand why this doesn't get injected automatically when set sourceLocale to en-GB
// import { registerLocaleData } from '@angular/common';
// import locale from '@angular/common/locales/en-GB';
// registerLocaleData(locale);

// custom modules
import {
  AdviceAidCommonModule,
  getReleaseStage,
  setWireValidationReporter,
} from "@aa/common";
import { AppRoutingModule } from "./app-routing.module";
import { CoreModule } from "./core";

// components
import { AppComponent } from "./app.component";
import { PAGE_COMPONENTS } from "./pages";
import { SharedModule } from "./shared";

import Bugsnag, { BrowserConfig } from "@bugsnag/js";
import BugsnagPerformance from "@bugsnag/browser-performance";
import { BugsnagErrorHandler } from "@bugsnag/plugin-angular";
import { ErrorHandler } from "@angular/core";
import { environment } from "../environments/environment";

// configure Bugsnag. The release stage comes from the server-stamped
// window.appConfig (one prod build serves staging and production). Reporting is
// limited to the deployed stages via enabledReleaseStages, so local dev and
// e2e runs (which report "development") initialise the SDK but send no events.
const bugsnagConfig: Pick<
  BrowserConfig,
  "apiKey" | "appVersion" | "releaseStage" | "enabledReleaseStages"
> = {
  apiKey: "48b0a86a5783ee1c9e6ce926598e74e9",
  appVersion: environment.version,
  releaseStage: getReleaseStage(environment),
  enabledReleaseStages: ["staging", "production"],
};

Bugsnag.start(bugsnagConfig);
BugsnagPerformance.start(bugsnagConfig);

// Forward Zod wire-schema validation failures to Bugsnag. The common library
// has no Bugsnag dependency, so the reporter is registered here at bootstrap
// (mirrors projects/app). Without this, selfserv wire-validation failures
// (e.g. the server-injected window.selfServMeta) were console-only with no
// Bugsnag visibility. See design/wiki/wire-schemas.md.
setWireValidationReporter(({ schemaName, issues, data }) => {
  const error = new Error(`Wire schema validation failed: ${schemaName}`);
  error.name = "WireValidationError";
  Bugsnag.notify(error, (event) => {
    event.addMetadata("wire", { schemaName, issues, data });
  });
});

export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

@NgModule({
  declarations: [AppComponent, ...PAGE_COMPONENTS],
  imports: [
    AdviceAidCommonModule,
    BrowserModule,
    CoreModule.forRoot(),
    AppRoutingModule,
    SharedModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "en-GB" },
    { provide: ErrorHandler, useFactory: errorHandlerFactory },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
